define(
	// TODO: This needs to be revisited when upgrading underscore as they put AMD support back in 1.6.
	function() {
		return window._;
	}
);
